import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Col } from "react-bootstrap";
import MethodHome from "./MethodHome";

export default function MethodList() {
  const { t } = useTranslation();

  return (
      <Fragment>
            <Breadcrumbs mainTitle={t("List of Test Methods")} parent={t("Home")} title={t("List of Test Methods")} />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <MethodHome/>
                    </Col>
                </Row>
            </Container>
        </Fragment>
  )
}
